import axios from 'axios';
import type { identifier } from '@core/models/base';
import type { JobOrderServiceDisplayModel } from '@shared/models/jobs/jobOrderServices';

export const fetchJobOrderServices = async (studioId: identifier, jobId: identifier) =>
  (await axios.get<JobOrderServiceDisplayModel[]>(`/api/customer/studios/${studioId}/jobs/${jobId}/services`)).data;
